<div class="flex flex-column gap-3" style="min-height: 40px;">
  <div class="w-full flex flex-wrap align-items-center justify-content-between gap-3">
    <div class="flex flex-column gap-2 ">
      <b class="inline-block col-12 sm:col-6 w-auto text-left font-medium text-2xl p-0">{{selectedSubmission?.question}}</b>
      <div class="flex gap-2 ">
      <div *ngFor="let submission of submissions; let i = index" class="inline-flex flex-wrap gap-2">
        <p-button  label="{{i+1}}" [styleClass]="'numbering ' + (submission === selectedSubmission ? 'active' : '')">
        </p-button>
      </div>
    </div>
    </div>
    <div class="w-auto  col-12  sm:col-6 inline-flex align-items-center gap-2 p-0">
      <div class="w-auto inline-flex align-items-center gap-1">
        <p-button (click)="traverseSubmissions('Prev')" label="Prev" icon="pi pi-angle-left" styleClass="prevnext"/>
        <p-button (click)="traverseSubmissions('Next')" label="Next" icon="pi pi-angle-right" styleClass="prevnext" iconPos="right"/>
      </div>
      <p-button label="Download" icon="pi pi-download" class="p-0" styleClass="downloadbtn" (onClick)="downloadEssay()"/>
    </div>
  </div>
  <div class="flex flex-column md:flex-row w-full gap-5 md:gap-0">
    <div class="md:col-7  col-12 p-0 md:pr-3">
      <div class="flex flex-column gap-2 border-1 border-round-lg p-3" style="background-color: #fff; border: 1px solid #B1C2D9;">
        <div  class="w-full flex flex-column gap-2 relative">
          <div class="w-full flex flex-column gap-2 " #targetText id="targetText" [innerHTML]="sanitizeHtml(selectedSubmission?.htmlAnswer)"></div>
          <!-- <button  #addCommentButton *ngIf="showAddCommentButton"  [ngStyle]="iconPosition" style="position: absolute; background-color: #007bff; color: white; border: none; padding: 5px 10px; border-radius: 4px; cursor: pointer; font-size: 0.8em;">
            <i class="pi pi-align-left"></i>
          </button> -->
          <p-button #addCommentButton class="absolute" [ngStyle]="{top: iconPosition.top, left: iconPosition.left}"
            *ngIf="showAddCommentButton"
            (onClick)="addNewComment($event) "
            icon="pi pi-align-left"
            styleClass="commentButton"/>
          <p-overlayPanel #op >
            <div class="flex flex-column gap-3 w-25rem">
              <form class="w-full flex flex-column gap-2" [formGroup]="commentForm" (ngSubmit)="onSubmit()" >
                <b class="w-full text-left font-medium" style="color: #000;">{{newCommentRequest?.selectedText}}</b>
                <textarea class="w-full" style="border: 1px solid #CCD7E7; border-radius: 4px; padding: 8px; box-sizing: border-box;"
                  rows="5"
                  cols="30"
                  placeholder="Write review.."
                  formControlName = "commentForm"
                  pInputTextarea >
                </textarea>
                <small class="text-red-500 block" *ngIf="commentForm.get('commentForm')?.invalid &&
                    (submitted || commentForm.get('commentForm')?.touched)">
                  Comment is required
                </small>
                <p-button [loading]="isLoading" label="Add Comment" styleClass="save_btn" type="submit"/>
              </form>
            </div>

        </p-overlayPanel>
          </div>
        <div class="w-full border-top-1 flex align-items-center justify-content-between mt-1"  style="border-color: #CCD7E7; padding-top: 12px;">
          <p class="text-sm font-normal inline-flex align-items-center gap-2 " style="color: #a0a0a0;"><i class="pi pi-check-circle"></i>Saved</p>
          <p class="text-sm font-normal" style="color: #a0a0a0;">Total Words: {{totalWords}}</p>
        </div>
      </div>
    </div>
    <div class="md:col-5 col-12  p-0 md:pl-3 flex flex-column">
        <b class="w-full p-3" style="border-radius: 8px 8px 0 0; font-size: 20px; background-color: #EDF2F9; border: 1px solid #B1C2D9;">Suggestions</b>
        <div class="w-full p-3 flex  flex-column gap-3" style="border-radius: 0 0 8px 8px; background-color: #F6F9FE; border: 1px solid #B1C2D9; border-top: none;">
          <div class="w-full flex flex-column gap-2">
            @for(comment of commentList; track comment)
            {
              <div class="w-full flex flex-column gap-2 p-3 bg-white" style="border: 1px solid #CCD7E7; border-radius: 4px; cursor: pointer;" (click)="highlightComment(comment.id)">
                  <div class="w-full flex align-items-center gap-2 justify-content-between">
                    <b class="w-full text-left font-medium" style="color: #000;">{{comment.selectedText}}</b>
                    <p-button (click)="deleteEssayComment(comment.id)" icon="pi pi-trash" class="flex-shrink-0" styleClass="deleteReviewBtn"/>
                  </div>
                  <p  style="font-size: 14px; color: #3F414A;">{{comment.comment}}</p>
                  <p class="pt-2 mt-2" style="border-top: 1px solid #CCD7E7; font-size: 13px; color: #898989;">{{comment.createdOn | date: 'MMM dd, yyyy'}}</p>
              </div>
            }
          </div>
        </div>
        <div class="flex align-items-center justify-content-center mt-2">
          <p-button class="w-full" *ngIf="commentList.length > 0" label="Submit Review" [loading]="isLoading" styleClass="save_btn" type="button"
            (onClick)="onSaveComment()"></p-button>
        </div>
    </div>
  </div>
</div>
